import * as tslib_1 from "tslib";
import api from '../api';
var DocumentsApi = /** @class */ (function () {
    function DocumentsApi() {
    }
    DocumentsApi.getAllDocuments = function (taskId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("documents/" + taskId)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    DocumentsApi.getDocumentTypes = function () {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("api/documenttypes")];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    DocumentsApi.uploadDocument = function (item) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var formData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append("file", item.file);
                        formData.append("type", item.type.toString());
                        formData.append("userId", item.userId.toString());
                        formData.append("relationId", item.relationId.toString());
                        formData.append("description", item.description);
                        return [4 /*yield*/, api.post('documents', formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentsApi.deleteDocument = function (documentId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.delete("documents/" + documentId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.status !== 500];
                }
            });
        });
    };
    return DocumentsApi;
}());
export default DocumentsApi;



//////////////////
// WEBPACK FOOTER
// ./src/services/DocumentsApi.ts
// module id = 739
// module chunks = 0